import React from 'react';
import {graphql} from 'gatsby';
import {convert} from 'html-to-text';
import {StaticImage} from 'gatsby-plugin-image';
import {useTranslation} from 'gatsby-plugin-react-i18next';

import SEO from '../../components/Seo';
import parse from '../../services/parse';
import PageLayout from '../../components/Pages/PageLayout/PageLayout';
import TextSection from '../../components/Pages/TextSection/TextSection';
import type {PageHeadProps} from '../../types/page';
import type {I18nTranslations} from '../../types/i18next';


const DataProtectionPage = () => {
  const {t} = useTranslation();

  return (
    <>
      <StaticImage
        src="../../assets/images/legal/data-protection-banner.webp"
        style={{minHeight: '8rem', maxHeight: '33vh'}}
        imgStyle={{objectPosition: '100% 0%'}}
        alt="Data Protection banner"
        loading="eager"
        quality={100}
      />

      <PageLayout title={t('data_protection.title')}>
        <TextSection>
          <p>{parse(t('data_protection.text'))}</p>
        </TextSection>
      </PageLayout>
    </>
  );
};


export default DataProtectionPage;


export const Head = ({data}: PageHeadProps) => {
  const translations: I18nTranslations = JSON.parse(data.locales.edges[0].node.data);

  return (
    <SEO
      title={`${translations.footer.copyright.data_protection} | ${translations.sethness_roquette}`}
      description={convert(translations.data_protection.text)}
    />
  );
};


export const query = graphql`
  query($language: String!, $defaultLang: String!) {
    locales: allLocale(filter: {language: {in: [$language, $defaultLang]}}) {
      ...I18nFragment
    },
  }
`;
